import { Component, OnInit } from '@angular/core';
import { AddAddressComponent } from '@app/shared/components/add-address/add-address.component';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { Pattern } from '@app/shared/validators/pattern';
import { MatchPassword } from '@app/shared/validators/passwordmatch';
import { AddressService } from '@app/shared/services/address/address.service';
import { UploadImageDialogComponent } from '@app/shared/components/upload-image-dialog/upload-image-dialog.component';
import { MessageService } from '@app/shared/services/common/message.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';


@Component({
  selector: 'app-enduser-profile',
  templateUrl: './enduser-profile.component.html',
  styleUrls: ['./enduser-profile.component.css']
})
export class EnduserProfileComponent implements OnInit {
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  isLinear!: any;
  public edited = true;
  public SSN_Value:any;
  editEndUserProfileForm: FormGroup;
  UserId: any;
  forceChangePassword : boolean = false;
  imageSrc !: any;
  addressList !: any[];
  constructor(private formBuilder: FormBuilder, private router: Router, private loader: LoaderService,
    private notificationService: NotificationService, private addressService: AddressService,
    private dialog: MatDialog, private messageService: MessageService, private errorhandlerService: ErrorhandlerService) {

    this.UserId = localStorage.getItem('userId');
    this.forceChangePassword = localStorage.getItem('ForceChangePassword') == "true" ? true : false;
    this.editEndUserProfileForm = this.formBuilder.group({
      FirstName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      LastName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      PhoneNumber: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CONTACT_NO_PATTERN),
        Validators.minLength(10), Validators.maxLength(10)])),
      CustomerAccountNumber: [''],
      Email: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.EMAIL_PATTERN)])),
      UserName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.EMAIL_PATTERN)])),
      ProfileImage: [''],
      SSN_No: new FormControl('',Validators.compose([Validators.required,Validators.pattern(Pattern.TIN_PATTERN)])),
      UserId: [this.UserId],
      ModifiedBy: [this.UserId],
      CurrentPassword: [''],
      Password: [''],
      ConfirmPassword: ['']
    }, {
        validator: MatchPassword.MatchPassword
      });
  }

  ngOnInit() { 
    this.addressList = [];
    this.getEndUserProfileById(this.UserId);
    this.fn_GetAllAddress();
  }
  Taxable(val:any,form: FormGroup){
  
   if(val==1){
    this.SSN_Value=val;
    this.edited = true;
    form.get('SSN_No').setValidators(Validators.compose([Validators.required,Validators.pattern(Pattern.TIN_PATTERN)]));
    form.get('SSN_No').updateValueAndValidity();
   }
   else{
    
    this.SSN_Value=val;
    this.edited = false;
    form.get('SSN_No').clearValidators();
    form.get('SSN_No').updateValueAndValidity();
   }

  }
  // convenience getter for easy access to form fields
  get f() { return this.editEndUserProfileForm.controls; }

  fn_OpenAddAdressDialog(): void {
    const dialogRef = this.dialog.open(AddAddressComponent, {
      disableClose: true,
      width: '540px'      
    });
    dialogRef.afterClosed().subscribe(result => {
      this.addressList = [];
      this.fn_GetAllAddress();
    });
  }
  /** Gets store data by storeid */
  getEndUserProfileById(endUserId: number) {
    this.loader.show();
    this.addressService.getStoreAdminById(endUserId).subscribe((res: any) => {
      this.editEndUserProfileForm.setValue({
        UserId: endUserId,
        SSN_No:res.Data.ResponseData.SSN_No,
        FirstName: res.Data.ResponseData.FirstName !== null ? res.Data.ResponseData.FirstName : '',
        LastName: res.Data.ResponseData.LastName !== null ? res.Data.ResponseData.LastName : '',
        PhoneNumber: res.Data.ResponseData.PhoneNumber !== null ? res.Data.ResponseData.PhoneNumber : '',
        CustomerAccountNumber: res.Data.ResponseData.CustomerAccountNumber !== null ? res.Data.ResponseData.CustomerAccountNumber : '',
        Email: res.Data.ResponseData.Email !== null ? res.Data.ResponseData.Email : '',
        UserName: res.Data.ResponseData.UserName !== null ? res.Data.ResponseData.UserName : '',
        CurrentPassword: '',
        Password: '',
        ConfirmPassword: '',
        ProfileImage: res.Data.ResponseData !== null ?
          res.Data.ResponseData.ProfileImage : '',
        ModifiedBy: endUserId,
      });
      this.imageSrc = localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png';
      this.loader.hide();
    }, err => {
      // this.notificationService.error('An error occured', 'Error');
      // this.router.navigate(['store/list']);
      this.errorhandlerService.handleError(err);
      this.loader.hide();
    });
  }
  fn_OnInputPassword(event: any) {
    if (event.currentTarget.value === '' || event.currentTarget.value == null) {
      this.editEndUserProfileForm.patchValue({
        CurrentPassword: '',
        Password: '',
        ConfirmPassword: '',
      });
  }}
  /** Update profile data */
  UpdateEndUserProfile(form: FormGroup) {
    if(this.SSN_Value==0){
      form.value.SSN_No=null;
    }
    this.loader.show();
    this.addressService.updateStoreAdminProfile(form.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        if(form.value.Password != ''){
          localStorage.removeItem('ForceChangePassword');
          this.forceChangePassword = false;
        }
        this.notificationService.success(res.Message, 'Profile');
        window.localStorage.setItem('profileImage', res.Data.LoginResponseModel.ProfileImage !== 'null' ?
          res.Data.LoginResponseModel.ProfileImage : 'assets/img/default_user_img.png'),
          window.localStorage.setItem('profileName', res.Data.LoginResponseModel.FullName !== 'null' ?
            res.Data.LoginResponseModel.FullName : ''),
          this.editEndUserProfileForm.patchValue({
            CurrentPassword: '',
            Password: '',
            ConfirmPassword: '',
          });
        this.imageSrc = localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png';
       const r = {
        profileImage: res.Data.LoginResponseModel.ProfileImage !== 'null' ?
        res.Data.LoginResponseModel.ProfileImage : 'assets/img/default_user_img.png',
        profileName: res.Data.LoginResponseModel.FullName,
        userRole: localStorage.getItem('role'),
        canEndUserCustomize: localStorage.getItem('canEndUserCustomize')
      };
    this.messageService.sendMessage(r);
      } else if (res.StatusCode === 400) {
        this.notificationService.error(res.Message, 'Try again');
      } else if (res.StatusCode === 500) {
        this.notificationService.error('An error occured', 'Try again');
      }
      this.loader.hide();
    }, err => {
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
      this.loader.hide();
    });
  }

  openUploadImageDialog(): void {
    const dialog = this.dialog.open(UploadImageDialogComponent, {
      disableClose: true,
      width: '550px',
      data: this.imageSrc
    });
    dialog.afterClosed().subscribe((res: any) => {
      if (res !== 'false') {
        this.imageSrc = res;
        this.editEndUserProfileForm.patchValue({
          ProfileImage: res
        });
      }
    });
  }

  /** Function to get all address */
  fn_GetAllAddress() {
    this.loader.show();
    this.addressService.getAllAddress(this.UserId).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.addressList = res.Data.ResponseData;
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, (err: any) => {
      this.errorhandlerService.handleError(err);
    });
  }

  /** function to open edit address dialog */
  fn_OpenEditAddressDialog(addressId: number) {
    const dialogRef = this.dialog.open(AddAddressComponent, {
      disableClose: true,
      width: '540px',
      data: { addressId }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.addressList = [];
      this.fn_GetAllAddress();
    });
  }
  /** function to delete the address from user profile addresses */
  fn_deleteAddress(addressId: number)  {
    this.loader.show();
    this.addressService.deleteAddress(addressId, this.UserId).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Address');
        this.fn_GetAllAddress();
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, (err: any) => {
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
      this.loader.hide();
    });
  }
}
